export default "__VITE_ASSET__5TycMqnH__"